import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import dashboard from "./pages/Dashboard.tsx";
import home from "./pages/Home.tsx";
import calendar from "./pages/Calendar.tsx";
import notes from "./pages/Notes.tsx";
import todo from "./pages/Todo.tsx";
import shoppinglist from "./pages/ShoppingList.tsx";
import weather from "./pages/Weather";


const router = createBrowserRouter([
    {
        Component: App, // root layout route
        children: [
            {
                path: '/',
                Component: home,
            },
            {
                path: '/dashboard',
                Component: dashboard,
            },
            {
                path: '/calendar',
                Component: calendar,
            },
            {
                path: '/notes',
                Component: notes,
            },
            {
                path: '/todo',
                Component: todo,
            },
            {
                path: '/shoppinglist',
                Component: shoppinglist,
            },
            {
                path: '/weather',
                Component: weather,
            },
        ],
    },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>,
);